import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Home from "./pages/Home";
import Sociedade from "./pages/Sociedade";
import Projetos from "./pages/Projetos";
import PrimeWash from "./pages/PrimeWash";
import Contactos from "./pages/Contactos";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sociedade" element={<Sociedade />} />
            <Route path="/projetos" element={<Projetos />} />
            <Route path="/primewash" element={<PrimeWash />} />
            <Route path="/contactos" element={<Contactos />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
